import Vue from 'vue'
import configMerge from '_u/config-merge'
// boot
import '@/styles/index.less'
import '@/boot/mutate'
import '@/boot/filter'
import '@/boot/mixin'
import baseConfig from '@/config'

// 创建vue根实例
export default function(App, pageConfig = {}) {
	// 合并config
	var config = configMerge(baseConfig, pageConfig),
		store = require(`@/boot/create-store`).default(),
		router = require(`@/boot/create-router`).default({
			store,
			routes: config.routes,
			mode: config.routerMode,
			base: config.routerBase,
		}),
		i18n = require(`@/boot/create-i18n`).default({
			store,
			router
		})

	// 环境配置
	Vue.config.productionTip = false
	Vue.$config = Vue.prototype.$config = config

	// install plugins
	var plugins = Object.assign({}, config.plugins)

	for (let name in plugins) {
		const value = plugins[name]

		if (!value) continue

		Vue.use(require(`@/plugins/${name}`).default, Object.assign({}, value, {
			store,
			router,
			i18n,
			config
		}))
	}

	// debug
	if (process.env.NODE_ENV === 'development') {
		require('./mock/index')
	}

	if (process.env.NODE_ENV === 'development') {
		for (let k in Vue) {
			if (k.startsWith("$")) {
				window[k] = Vue[k]
			}
		}
		window.$helper = require('@/utils/helper')
		window.$ls = require('@/utils/ls')
	}

	if (process.env.VUE_APP_MODE != "rc") {
		console.log("process.env.NODE_ENV = " + process.env.NODE_ENV)
		console.log("process.env.VUE_APP_MODE = " + process.env.VUE_APP_MODE)
		console.log("process.env.VUE_APP_SERVER = " + process.env.VUE_APP_SERVER)
		console.log("process.env.VUE_APP_PUBLICK_PATH = " + process.env.VUE_APP_PUBLICK_PATH)
		console.log("process.env.VUE_APP_DEV_PROXY_TARGET = " + process.env.VUE_APP_DEV_PROXY_TARGET)
		console.log("process.env.VUE_APP_TARGET = " + process.env.VUE_APP_TARGET)
	}

	// init root
	var _opt = {
		render: h => h(App)
	}

	if (router) {
		_opt.router = router
	}

	if (store) {
		_opt.store = store
	}

	if (i18n) {
		_opt.i18n = i18n
	}

	return new Vue(_opt).$mount('#app')
}
